import React from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-ultimate-pagination-bootstrap-4';

import ManagedResourceList from '../shared/ManagedResourceList';
import PageHeader from '../PageHeader';

import './styles/view_mms.scss';

class SnippetHistory extends React.Component {
  static defaultProps = {
    columns: [],
    displayType: '',
    header: '',
    page: 1,
    selected: null,
    snippets: [],
    totalPages: 1,

    loadPage: () => false,
    onPageChange: () => false,
    onSelect: () => false,
    showModal: () => false
  };

  static propTypes = {
    columns: PropTypes.array.isRequired,
    displayType: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    selected: PropTypes.object,
    snippets: PropTypes.array.isRequired,
    totalPages: PropTypes.number.isRequired,

    loadPage: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
  };

  render() {
    const {
      columns,
      displayType,
      header,
      loadPage,
      page,
      selected,
      onPageChange,
      onSelect,
      showModal,
      snippets,
      totalPages
    } = this.props;

    const pagination = snippets.length > 0 && totalPages > 1 && <div className="pagination pagination-right">
      <Pagination
        currentPage={page}
        totalPages={totalPages}
        hideFirstAndLastPageLinks={true}
        onChange={(pageNum) => onPageChange(pageNum)}
      />
    </div>;

    return <div>
      <PageHeader header={header}/>
      {pagination}
      <ManagedResourceList
        items={snippets}
        fetchItems={() => loadPage(1)}
        displayType={displayType}
        columns={columns}
        collectionButtons={[]}
        itemButtons={[
          ({item}) => <a href='#' onClick={() => onSelect(item)}>Show</a>
        ]}
      />
      {pagination}
      {
        selected && <div>
          {showModal(selected, () => onSelect(null))}
        </div>
      }

    </div>;
  }

  componentDidMount() {
    const {loadPage, page} = this.props;

    loadPage(page);
  }

  componentWillUpdate(nextProps) {
    const {loadPage, page} = this.props;

    if (page !== nextProps.page) {
     loadPage(nextProps.page);
    }
  }
}

export default SnippetHistory;
